"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryRule = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const deliveryRulesConstants_1 = require("./deliveryRulesConstants");
class DeliveryRule {
    constructor(definition) {
        this.definition = definition ?? {};
    }
    static deliveryRuleFromProps(options) {
        const definition = {
            delivery: {},
            orderBy: {
                daysBefore: options.orderDaysBefore,
                time: options.orderByTime,
            },
        };
        if (options.date !== undefined) {
            definition.delivery.date = options.date;
        }
        else if (options.deliveryWeekDay !== undefined) {
            definition.delivery.weekday = options.deliveryWeekDay;
        }
        if (options.blocked) {
            definition.delivery.blocked = options.blocked;
        }
        if (!lodash_1.default.isNil(options.region)) {
            definition.applicableWhen = {
                validZipCodes: [options.region],
            };
        }
        return new DeliveryRule(definition);
    }
    static createSelectedRoute(weekday) {
        return new DeliveryRule({
            selectedRoute: { weekday },
        });
    }
    getDefinition() {
        return this.definition;
    }
    getKey() {
        return (this.definition.delivery?.weekday ??
            this.definition.delivery?.date ??
            this.definition.selectedRoute?.weekday ??
            null);
    }
    getDeliveryWeekday() {
        return this.definition.delivery?.weekday;
    }
    setDeliveryWeekday(weekday) {
        lodash_1.default.set(this.definition, 'delivery.weekday', weekday);
    }
    getSelectedWeekday() {
        return this.definition.selectedRoute?.weekday;
    }
    setSelectedWeekday(weekday) {
        lodash_1.default.set(this.definition, 'selectedRoute.weekday', weekday);
    }
    getDate() {
        return this.definition.delivery?.date;
    }
    setDate(date) {
        lodash_1.default.set(this.definition, 'delivery.date', date);
    }
    getRegion() {
        return (this.definition.applicableWhen?.validZipCodes?.join(',') ||
            deliveryRulesConstants_1.DeliveryRulesGeneralRegion);
    }
    setRegion(region) {
        if (region === deliveryRulesConstants_1.DeliveryRulesGeneralRegion) {
            lodash_1.default.unset(this.definition, 'applicableWhen.validZipCodes');
            return;
        }
        lodash_1.default.set(this.definition, 'applicableWhen.validZipCodes', region.split(','));
    }
    getTime() {
        return this.definition.orderBy?.time;
    }
    setTime(time) {
        lodash_1.default.set(this.definition, 'orderBy.time', time);
    }
    getDaysBefore() {
        return this.definition.orderBy?.daysBefore;
    }
    setDaysBefore(daysBefore) {
        lodash_1.default.set(this.definition, 'orderBy.daysBefore', daysBefore);
    }
    isBlocked() {
        return this.definition.delivery?.blocked;
    }
    setBlockedDelivery(blocked) {
        lodash_1.default.set(this.definition, 'delivery.blocked', blocked);
        if (blocked) {
            delete this.definition.orderBy;
        }
    }
    getBreakTimeForDate(forDate) {
        if (!this.definition ||
            !this.definition.delivery ||
            this.definition.delivery?.blocked) {
            return null;
        }
        if (this.definition.orderBy) {
            moment_1.default.tz.setDefault('Europe/Stockholm');
            const dayToCheck = (0, moment_1.default)(forDate).subtract(this.definition.orderBy.daysBefore, 'days');
            const timeParts = this.definition.orderBy.time.split(':');
            const breakTimeForDateInUtc = dayToCheck
                .hour(timeParts[0] ? parseInt(timeParts[0], 10) : 0)
                .minute(timeParts[1] ? parseInt(timeParts[1], 10) : 0)
                .toDate();
            moment_1.default.tz.setDefault();
            return breakTimeForDateInUtc;
        }
        return forDate;
    }
    exportAsDeliveryRuleDefinition() {
        return this.definition;
    }
}
exports.DeliveryRule = DeliveryRule;
